import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { DAY_MONTH_NAME_SHORT, DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import LesaPurchaseSummaryOrderItemStatus from './LesaPurchaseSummaryOrderItemStatus'

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(${rem(16)}, max-content) 1fr;
  grid-template-rows: auto;
  grid-row-gap: ${rem(4)};
`

const StyledBookingNumber = styled.div`
  grid-column: 1 / span 2;
`

interface Props {
  startDate?: string | null;
  endDate?: string | null;
  duration?: string | number;
  bookingNumber?: string;
  status?: App.OrderItemStatus;
  showReservationDates?: boolean;
}

export default function LesaPurchaseSummaryItineraryDates(props: Props) {
  const { showReservationDates, status, startDate, endDate, duration, bookingNumber } = props

  return (
    <Container>
      {!startDate && <LesaPurchaseSummaryOrderItemStatus status={status} />}
      {showReservationDates && startDate && <BodyTextBlock variant="small" colour="neutral-two">
        {moment(startDate).format(DAY_MONTH_NAME_SHORT)}
        {' '}-{' '}
        {moment(endDate).format(DMY_CASUAL_SHORT_FORMAT)}
        {' '}{duration && <>({duration})</>}
      </BodyTextBlock>}
      {bookingNumber && <StyledBookingNumber>
        <BodyTextBlock variant="small" colour="neutral-two"><strong>Booking ID:</strong> {bookingNumber}</BodyTextBlock>{' '}
      </StyledBookingNumber>}
    </Container>
  )
}
